import React from 'react';
import { motion } from 'framer-motion';
import { Clock, CheckCircle2, Upload, FileText, Eye } from 'lucide-react';
import { LoanDocument } from '../types';
interface DocumentItemProps {
  document: LoanDocument;
  onUploadClick: (doc: LoanDocument) => void;
}
export function DocumentItem({
  document,
  onUploadClick
}: DocumentItemProps) {
  const isPending = document.status === 'pending';
  const isUploaded = document.status === 'uploaded';
  const isApproved = document.status === 'approved';
  return <motion.div layout initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className={`
        group flex flex-col sm:flex-row sm:items-center justify-between p-5 rounded-xl border transition-all duration-200
        ${isPending ? 'bg-white border-gray-200 hover:border-gray-300 hover:shadow-sm' : ''}
        ${isUploaded ? 'bg-emerald-50/30 border-emerald-100' : ''}
        ${isApproved ? 'bg-green-50/30 border-green-100' : ''}
      `} data-id="element-14">
      <div className="flex items-start sm:items-center mb-4 sm:mb-0" data-id="element-15">
        <div className={`
          w-10 h-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0
          ${isPending ? 'bg-gray-100 text-gray-500' : ''}
          ${isUploaded ? 'bg-emerald-100 text-emerald-600' : ''}
          ${isApproved ? 'bg-green-100 text-green-600' : ''}
        `} data-id="element-16">
          <FileText className="w-5 h-5" data-id="element-17" />
        </div>

        <div data-id="element-18">
          <h4 className="text-sm font-semibold text-slate-900" data-id="element-19">
            {document.name}
          </h4>
          <p className="text-xs text-slate-500 mt-0.5" data-id="element-20">
            {document.description}
          </p>

          {(isUploaded || isApproved) && document.fileName && <div className="flex items-center mt-2 text-xs text-slate-600 bg-white/60 px-2 py-1 rounded border border-slate-100 inline-flex" data-id="element-21">
              <span className="truncate max-w-[200px]" data-id="element-22">
                {document.fileName}
              </span>
              {document.uploadedAt && <span className="text-slate-400 ml-2 border-l border-slate-200 pl-2" data-id="element-23">
                  {document.uploadedAt}
                </span>}
            </div>}
        </div>
      </div>

      <div className="flex items-center justify-between sm:justify-end w-full sm:w-auto gap-4 pl-14 sm:pl-0" data-id="element-24">
        {/* Status Badge */}
        <div className={`
          flex items-center px-2.5 py-1 rounded-full text-xs font-medium
          ${isPending ? 'bg-amber-100 text-amber-700' : ''}
          ${isUploaded ? 'bg-emerald-100 text-emerald-700' : ''}
          ${isApproved ? 'bg-green-100 text-green-700' : ''}
        `} data-id="element-25">
          {isPending && <Clock className="w-3 h-3 mr-1.5" data-id="element-26" />}
          {isUploaded && <CheckCircle2 className="w-3 h-3 mr-1.5" data-id="element-27" />}
          {isApproved && <CheckCircle2 className="w-3 h-3 mr-1.5" data-id="element-28" />}
          <span className="capitalize" data-id="element-29">{document.status}</span>
        </div>

        {/* Action Button */}
        {isPending ? <button onClick={() => onUploadClick(document)} className="flex items-center px-3 py-1.5 text-sm font-medium text-white bg-green-600 hover:bg-green-700 rounded-lg transition-colors" data-id="element-30">
            <Upload className="w-4 h-4 mr-1.5" data-id="element-31" />
            Upload
          </button> : <button className="flex items-center px-3 py-1.5 text-sm font-medium text-slate-600 bg-white border border-slate-200 hover:bg-slate-50 rounded-lg transition-colors" data-id="element-32">
            <Eye className="w-4 h-4 mr-1.5" data-id="element-33" />
            View
          </button>}
      </div>
    </motion.div>;
}